import { useState, useMemo } from "react";
import {
  Stack,
  Title,
  Group,
  Paper,
  Text,
  Badge,
  Button,
  SegmentedControl,
} from "@mantine/core";
import { DataTable } from "../../DataTable";

export function ResultsStep({ uploadResults, onFinish }) {
  const [filter, setFilter] = useState("all");

  const filteredRecords = useMemo(() => {
    if (filter === "success")
      return (uploadResults?.details || []).filter(
        (r) => r.status === "success"
      );
    if (filter === "error")
      return (uploadResults?.details || []).filter((r) => r.status === "error");
    return uploadResults?.details || [];
  }, [uploadResults, filter]);

  return (
    <Stack gap="md">
      <Title order={3}>Upload Results</Title>
      <Group grow>
        <Paper
          withBorder
          p="md"
          radius="md"
          style={{
            borderLeft: "4px solid var(--mantine-color-green-filled)",
          }}
        >
          <Text size="xs" c="dimmed" tt="uppercase" fw={700}>
            Success
          </Text>
          <Text size="xl" fw={700}>
            {uploadResults?.successCount}
          </Text>
        </Paper>
        <Paper
          withBorder
          p="md"
          radius="md"
          style={{
            borderLeft: "4px solid var(--mantine-color-red-filled)",
          }}
        >
          <Text size="xs" c="dimmed" tt="uppercase" fw={700}>
            Failed
          </Text>
          <Text size="xl" fw={700}>
            {uploadResults?.errorCount}
          </Text>
        </Paper>
      </Group>

      <DataTable
        columns={[
          { accessor: "filename", title: "Filename" },
          {
            accessor: "status",
            title: "Status",
            filter: (
              <SegmentedControl
                value={filter}
                onChange={setFilter}
                size="xs"
                data={[
                  { label: "All", value: "all" },
                  { label: "Success", value: "success" },
                  { label: "Error", value: "error" },
                ]}
              />
            ),
            filtering: filter !== "all",
            render: (record) => (
              <Badge color={record.status === "success" ? "green" : "red"}>
                {record.status}
              </Badge>
            ),
          },
          { accessor: "message", title: "Details" },
        ]}
        records={filteredRecords}
        withTableBorder={true}
        withColumnBorders={true}
        striped
        height={300}
      />

      <Group justify="center" mt="xl">
        <Button onClick={onFinish}>Finish & View Documents</Button>
      </Group>
    </Stack>
  );
}
